import { translate } from '../../util/translator';

const nextStepEl = document.getElementById('js-nextStep');
const tireSizeSelectionEl = document.getElementById('js-tireSizeSelectionEl');
const shopRegionSelectionEl = document.getElementById(
  'js-shopRegionSelectionEl'
);
const regionSelectEl = document.getElementById('js-regionsList');
const garageSelectEl = document.getElementById('js-garagesList');
const goToShopContainerEl = document.getElementById('js-goToShopContainer');
const goToShopBtnEl = document.getElementById('js-goToShop');
let tireSizeSelectValue;

const regions = [];

export default function() {
  if (nextStepEl) {
    nextStepEl.addEventListener('click', nextStep);
  }

  if (regionSelectEl) {
    regionSelectEl.addEventListener('change', function() {
      updateGarages(regionSelectEl.value);
      buildUrl();
    });
  }

  if (garageSelectEl) {
    garageSelectEl.addEventListener('change', function() {
      buildUrl();
    });
  }
}

function updateGarages(value) {
  removeOptions(garageSelectEl);

  const garages = regions.find(region => region.id === parseInt(value)).garages;
  const defaultOption = document.createElement('option');
  defaultOption.innerHTML = translate('choose-workshop', 'Wybierz warsztat');
  defaultOption.setAttribute('selected', 'selected');
  defaultOption.setAttribute('disabled', 'disabled');
  defaultOption.setAttribute('hidden', 'hidden');
  defaultOption.value = '';
  garageSelectEl.appendChild(defaultOption);

  garages.map(garage => {
    const option = document.createElement('option');
    option.value = garage.slug;
    option.innerHTML = `${garage.name} (${garage.city})`;
    garageSelectEl.appendChild(option);
  });
}

function removeOptions(select) {
  for (let i = select.options.length - 1; i >= 0; i--) {
    select.remove(i);
  }
}

function nextStep() {
  groupGaragesByRegion();
  for (let i = 0; regions.length > i; i++) {
    const option = document.createElement('option');
    option.value = regions[i].id;
    option.innerHTML = regions[i].name;
    regionSelectEl.appendChild(option);
  }

  tireSizeSelectValue = document.querySelector('#js-tireSizesList').value;
  nextStepEl.classList.add('d-none');
  tireSizeSelectionEl.classList.add('d-none');
  shopRegionSelectionEl.classList.remove('d-none');

  buildUrl();

  goToShopContainerEl.classList.remove('d-none');
}

function groupGaragesByRegion() {
  for (let i = 0; regionsListAPI.length > i; i++) {
    if (garagesListAPI.some(x => x.region.id == regionsListAPI[i].id)) {
      const obj = {};
      obj.garages = garagesListAPI.filter(
        garage => garage.region.id === regionsListAPI[i].id
      );
      obj.id = regionsListAPI[i].id;
      obj.name = regionsListAPI[i].name;

      regions.push(obj);
    }
  }
}

function filterRegion(garage) {
  return garage.region.id === parseInt(regionSelectEl.value);
}

function filterRegions(regions, garages) {
  return regions.filter(region => {
    return !garages.includes(region.id);
  });
}

function buildUrl() {
  const product = {
    name: productName.replace(/[^a-zA-Z0-9 ]/g, ''),
    brand: productBrand,
    type: JSON.parse(productType).value
  };

  const sizeParts = tireSizeSelectValue.split('-');
  const size = {
    width: sizeParts[0],
    aspectRatio: sizeParts[1],
    diameter: sizeParts[2].replace('r', '')
  };
  // EXAMPLE https://bestdrive.webshop.pl/opony/osobowa/205-55-16?pd=CONTINENTAL
  // EXAMPLE https://bestdrive.webshop.pl/opony/zimowa/osobowa/205-55-16?sz=205&pr=55&sr=16&pt=osobowa&se=zimowa&pd=CONTINENTAL
  // EXAMPLE https://bestdrive.webshop.pl/opony/osobowa/205-55-16?sz=205&pr=55&sr=16&pt=osobowa&pd=CONTINENTAL&pb=PREMIUMCONTACT%206&k=autoexpert
  const url = `${shopURL}opony/${product.type}/${size.width}-${size.aspectRatio}-${size.diameter}?sz=${size.width}&pr=${size.aspectRatio}&sr=${size.diameter}&pt=${product.type}&pd=${product.brand}&pb=${product.name}&k=${garageSelectEl.value}`;

  goToShopBtnEl.href = url;
}
